var _path, _path2, _path3, _path4, _g, _path5, _path6, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrigger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9833_5784)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9833_5784",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 0H0V48H48V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9833_5784)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9833_5784",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H8C3.58172 0 0 3.58172 0 8V40C0 44.4183 3.58172 48 8 48H40C44.4183 48 48 44.4183 48 40V8C48 3.58172 44.4183 0 40 0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9833_5784)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H8C3.58172 0 0 3.58172 0 8V40C0 44.4183 3.58172 48 8 48H40C44.4183 48 48 44.4183 48 40V8C48 3.58172 44.4183 0 40 0Z",
    fill: "url(#paint0_linear_9833_5784)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9833_5784",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48 0H0V48H48V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9833_5784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 0H8C3.58172 0 0 3.58172 0 8V40C0 44.4183 3.58172 48 8 48H40C44.4183 48 48 44.4183 48 40V8C48 3.58172 44.4183 0 40 0Z",
    fill: "url(#paint1_linear_9833_5784)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_9833_5784",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 24,
    height: 24
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36 12H12V36H36V12Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_9833_5784)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_9833_5784",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 12,
    width: 13,
    height: 24
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31 12H18V36H31V12Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_9833_5784)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2181 20.962H25.0566L27.2106 12.7499C27.2506 12.5176 27.1706 12.2888 27.0071 12.194C26.9671 12.1484 26.8871 12.1484 26.8438 12.1484C26.7236 12.1484 26.6003 12.2399 26.5203 12.3348L18.1913 26.2047C18.1113 26.3419 18.1113 26.5282 18.1513 26.669C18.2346 26.8062 18.3546 26.8977 18.5181 26.8977H23.5131L21.2791 35.2471C21.2391 35.4794 21.3223 35.7117 21.4826 35.8065C21.5226 35.8521 21.6058 35.8521 21.6458 35.8521C21.7691 35.8521 21.8893 35.7605 21.9693 35.6657L30.5418 21.6589C30.5818 21.5638 30.6251 21.4725 30.6251 21.381C30.6251 21.1487 30.4216 20.962 30.2181 20.962Z",
    fill: "white"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9833_5784",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4566E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E399E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9833_5784",
    x1: 12.7781,
    y1: 9.24074,
    x2: 39.2241,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#665DFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E274D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9833_5784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrigger);
export default __webpack_public_path__ + "static/media/Trigger.b704ccad220fe6500eb600a574b4acde.svg";
export { ForwardRef as ReactComponent };